<template>
  <v-select
      v-model="item"
      dir="rtl"
      :multiple="multiple"
      label="Title"
      :clearable="clearable"
      :reduce="x => x.Id"
      :options="type == null ? items : items.filter(x => x.Type == type)"
      :loading="loading"
      :selectable="x => unselectable.includes(x.Id) === false || x === val"
      @open="onOpen"
      @option:selected="$emit('selected',$event)"
  >
    <span
        slot="no-options"
        @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
            v-if="loading"
            class="m-0"
            small
            variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ZBlogCategory',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    type: {
      type:  Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.blogCategorySelect }),
    ...mapState('zirehState', { flag: state => state.blogCategorySelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setBlogCategorySelectFlag', true)
        this.loading = true
        this.$http.post(
            this.$api.blogcategory.getall, {},
        )
            .then(res => {
              this.$store.commit('zirehState/setBlogCategorySelect', res.data)
              this.loading = false
            })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
